import { QueryHookOptions } from '@apollo/client';

import { useInfiniteQuery } from 'hooks/useInfiniteQuery';

import query from './managedTeamFilters.graphql';

export const useTeamsFiltersQuery = (
  options?: QueryHookOptions<
    ManagedTeamFiltersQuery,
    ManagedTeamFiltersQueryVariables
  >,
) => {
  return useInfiniteQuery<
    ManagedTeamFiltersQuery,
    ManagedTeamFiltersQueryVariables
  >(query, {
    fieldName: 'managedSentinelTeams',
    ...options,
  });
};
